import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import {
    Gauge, LMX,
} from 'frontend-charts'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Tabs from './Tabs'
import Accordion from '../../ReportV2/components/Accordion'
import Checkbox from '../../form/Checkbox'
import Spinner from '../../../UniformComponents/Spinner'

@observer
class NonQuestionChart extends PureComponent {
    multiQuestion = {
        chart: (
            <div className="multiQuestonContainer">
                <div className="multiQueston">
                    <div className="tl"><div>KPI</div></div>
                    <div className="tr"><div>KPI</div></div>
                    <div className="bl"><div>KPI</div></div>
                    <div className="br"><div>KPI</div></div>
                </div>
            </div>
        ),
        title: 'Multi Question KPI Chart',
        description: 'Display more than one question on a chart',
        key: 'multiQuestion',
        defaultSize: 2,
    }

    lmx = {
        chart: (
            <LMX
                chartData={[
                    { name: '', value: '' },
                    { name: '', value: '' },
                    { name: '', value: '' },
                    { name: '', value: '' },
                ]}
                style={{ height: '90px', width: '150px' }}
            />
        ),
        title: 'Loyalty vs Satisfaction Matrix ',
        description: 'Show the loyalty vs the satisfaction on respondents',
        key: 'LMX',
        defaultSize: 8,
    }

    quadrantAnlysis = {
        chart: (
            <div className="quadrantAnalysisContainer">
                <div className="quadrantAnalysis">
                    <div className="tl"><div className="ss" /></div>
                    <div className="tr"><div className="ss" /></div>
                    <div className="bl bottom"><div className="ss" /></div>
                    <div className="br bottom"><div className="ss" /></div>
                </div>
            </div>
        ),
        title: 'Quadrant Analysis',
        description: 'A scatter chart showing your key metrics',
        key: 'quadrantAnalysis',
        defaultSize: 8,
    }

    constructor(props) {
        super(props)
        const { dashboardWizardStore } = props
        dashboardWizardStore.getNonQuestionData()
        this.state = {
            error: {
                chart: false,
            },
        }
    }

    kpiChart = (title, key, description) => ({
        chart: <Gauge
            chartData={45}
            style={{ height: '90px', width: '150px' }}
            containerSize={{ height: 190, width: 190 }}
            layoutEdit={[
                {
                    path: ['series', 0, 'pointer', 'width'],
                    value: 15,
                },
                {
                    path: ['series', 0, 'axisTick', 'distance'],
                    value: -15,
                },
                {
                    path: ['series', 0, 'detail', 'rich', 'a', 'fontSize'],
                    value: 25,
                },
                {
                    path: ['series', 0, 'detail', 'rich', 'a', 'lineHeight'],
                    value: 25,
                },
                {
                    path: ['series', 0, 'detail', 'offsetCenter'],
                    value: [0, '35%'],
                },
            ]}
        />,
        title,
        description,
        key,
        defaultSize: 2,
    })

    renderChart = ({
        chart, title, description, key, defaultSize,
    }, kpi) => {
        const { dashboardWizardStore } = this.props
        const { newWidget } = dashboardWizardStore
        return (
            <div
                className={`chartContainer ${key === newWidget.nonQuestionKpiType ? 'active' : ''}`}
                onClick={() => this.changeChart(key, defaultSize, kpi)}
            >
                <div className="chart">
                    {chart}
                </div>
                <div className="description" style={{ width: '200px' }}>
                    <div className="title">
                        {title}
                    </div>
                    <div className="subTitle">{description}</div>
                </div>
                <div className="input">
                    <Checkbox
                        checked={key === newWidget.nonQuestionKpiType}
                    />
                </div>
            </div>
        )
    }

    changeChart = (key, defaultSize, kpi) => {
        const { dashboardWizardStore } = this.props
        const {
            setChart,
            newWidget,
            addNonQuestionStages,
            addMultiStages,
            changeNewWidget,
            addQuadrantStages,
            changeNonWidgetReset,
        } = dashboardWizardStore
        const { error } = this.state
        changeNonWidgetReset(kpi)
        if (key !== newWidget.nonQuestionKpiType) {
            changeNewWidget(key, 'nonQuestionKpiType')
            changeNewWidget(defaultSize, 'defaultSize')
        }
        if (key === 'question' || key === 'LMX') addNonQuestionStages()
        if (key === 'multiQuestion') addMultiStages()
        if (key === 'quadrantAnalysis') addQuadrantStages()
        changeNewWidget(['multiQuestion', 'quadrantAnalysis'].includes(key) ? key : 'KPI', 'nonQuestionType')
        this.setState({ error: { ...error, chart: false } })
    }

    renderCharts = () => {
        const { dashboardWizardStore } = this.props
        const { getAllowedKpis, newWidget, dashStore } = dashboardWizardStore
        const { oId: dashboardOid } = dashStore
        const {
            respondentType, industry, surveyType, productType,
        } = newWidget

        const kpis = getAllowedKpis()
            .filter((k) => (
                k.respondentType === respondentType
                && k.industry === industry
                && k.surveyType === surveyType
                && k.productType === productType
            ))

        const kpiCharts = kpis.map((kpi) => {
            const chart = kpi.kpiId === 'LMX' ? this.lmx : this.kpiChart(kpi.name, kpi.kpiId, kpi.description)
            return this.renderChart(chart, kpi)
        })

        const { multiQuestion, quadrantAnlysis } = this

        return [
            kpiCharts,
            this.renderChart(multiQuestion),
            dashboardOid < 6 ? this.renderChart(quadrantAnlysis) : null, // hide on oid 6 (product)
        ].flat()
    }

    continue = async () => {
        const { dashboardWizardStore } = this.props
        const {
            newWidget, nextStage, changeNewWidget, getQuestions,
        } = dashboardWizardStore
        const { error } = this.state
        if (!newWidget.nonQuestionKpiType) {
            this.setState({ error: { ...error, chart: true } })
            return
        }

        if (newWidget.nonQuestionKpiType === 'quadrantAnalysis') {
            changeNewWidget('quadrantAnalysis', 'chart')
        }
        if (['quadrantAnalysis', 'multiQuestion'].includes(newWidget.nonQuestionKpiType)) {
            getQuestions(true)
        } else {
            getQuestions()
        }
        nextStage()
    }

    addWidget = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, addWidget } = dashboardWizardStore
        const { error } = this.state
        if (!newWidget.nonQuestionKpiType) {
            this.setState({ error: { ...error, chart: true } })
            return
        }
        addWidget()
    }

    render() {
        const { dashboardWizardStore } = this.props
        const { previousStage, loading, newWidget } = dashboardWizardStore
        const { chart } = newWidget
        const { error } = this.state
        if (loading) return <Spinner />
        return (
            <div className="noQuestionChart">
                <Tabs dashboardWizardStore={dashboardWizardStore} />
                <ModalHeader cssClass="header">
                    <div className="title">
                        Chart Options
                    </div>
                    <div className="subTitle">
                        Select your widget type
                    </div>
                </ModalHeader>
                <div className="body" style={{ padding: '0 100px' }}>
                    <div className="accordian widgetType" style={{ marginBottom: '15px' }}>
                        <Accordion
                            cssClass="chartAccordian"
                            title={(
                                <div className="title">
                                    Select your widget type
                                    <i
                                        className="fa-regular fa-circle-exclamation"
                                        style={
                                            {
                                                color: 'red',
                                                background: 'none',
                                                marginLeft: '20px',
                                                display: error.chart ? 'block' : 'none',
                                            }
                                        }
                                    />
                                </div>
                            )}
                            openIcon="fa-regular fa-chevron-up"
                            closeIcon="fa-regular fa-chevron-down"
                            defaultOpen
                        >
                            <div className="widgets">
                                {this.renderCharts()}
                            </div>
                        </Accordion>
                    </div>
                </div>
                <ModalFooter>
                    <Button
                        label="Back"
                        cssClass="tertiary regular"
                        style={{ marginRight: '25px', width: '134px' }}
                        onClick={previousStage}
                    />
                    <Button
                        label="Continue"
                        cssClass="primary regular"
                        style={{ width: '134px' }}
                        onClick={this.continue}
                    />
                </ModalFooter>
            </div>
        )
    }
}

export default NonQuestionChart
